<template>
  <div class="h-screen">
    <div class="relative h-full">
      <base-picture
        class="full"
        fit="cover"
        height="320"
        :props-img="{ class: 'w-full', style: 'object-position: top right', role: 'presentation' }"
        :src="{
          sm: 'https://assets.timberland.com/image/upload/q_auto,f_auto/v1723688110/TBL-403-error-320',
          md: 'https://assets.timberland.com/image/upload/q_auto,f_auto/v1723688110/TBL-403-error-768',
          lg: 'https://assets.timberland.com/image/upload/q_auto,f_auto/v1723688110/TBL-403-error-1024',
        }"
        width="320"
      />

      <div class="absolute-0">
        <div class="pt-16 c-white container">
          <h1 class="display-3 md:max-w-3/5">
            {{ $t.maintenance.ERR4xx.title }}
          </h1>
          <p class="pb-12 pt-4 md:max-w-3/5 md:pb-8 lg:pt-6">
            {{ $t.maintenance.ERR4xx.message }}
          </p>
          <vf-button class="<md:w-full" size="md" variant="primary-inverse" @click="clearError({ redirect: '/' })">
            {{ $t.maintenance.ERR4xx.cta }}
          </vf-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { $feature, $t } = useNuxtApp()
useSeoMeta({ title: $t.error, robots: $feature.enableNoindexOnErrorPages ? 'noindex, nofollow' : '' })
</script>
